import Tooltip from '@creditflowresearch/uilib/Tooltip';

interface IAttributeCellProps {
  cellData: string[],
  countItemVisible?: number,
}

const AttributeCell = ({ cellData, countItemVisible = 2 }: IAttributeCellProps) => {
  if (cellData.length > countItemVisible) {
    return (
      <Tooltip content={ cellData.join(', ') }>
        {
          `${ cellData.slice(0, countItemVisible).join(', ') }, ...`
        }
      </Tooltip>
    );
  }

  return cellData.join(', ');
};

export default AttributeCell;
